module.exports = __webpack_public_path__ + "img/semiRing1.3ea31487.svg";